export const PAGE_CORRECT_DOMAIN_SETTINGS_MODULE = {
    SPELLING_ERROR: 'spelling_error',
    ACCESSIBILITY_SOURCE_CODE: 'accessibility_source_code',
    ACCESSIBILITY_CHECK: 'accessibility_check',
    LINK: 'link',
    CUSTOM: 'custom',
} as const;
